var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubleSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 320C324.149 320 391.664 247.459 383.298 161.623C376.006 86.812 308.759 32 233.594 32L104 32C81.909 32 64 49.909 64 72V272H24C10.75 272 0 282.75 0 296S10.75 320 24 320H64V368H24C10.75 368 0 378.75 0 392S10.75 416 24 416H64V456C64 469.25 74.75 480 88 480S112 469.25 112 456V416H296C309.25 416 320 405.25 320 392S309.25 368 296 368H112V320H240ZM112 272V80L236.211 80C282.639 80 325.286 111.29 334.139 156.866C346.044 218.154 299.196 272 240 272H112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubleSign);
export default __webpack_public_path__ + "static/media/ruble-sign.524b708548c53612b0c88a5bef6d4f81.svg";
export { ForwardRef as ReactComponent };